import React, { useState, useEffect, useRef } from "react";
import {
  Row,
  Col,
  Form,
  Select,
  Button,
  Modal,
  Input,
  notification,
  Typography,
  Space,
  Card,
  Table,
  Radio,
  DatePicker,
  Checkbox,
  message,
  Menu,
  Dropdown,
  Popover,
  Tag,
} from "antd";
import {
  AccountBookOutlined,
  ArrowLeftOutlined,
  CalendarOutlined,
  CheckCircleOutlined,
  CheckSquareOutlined,
  CloseSquareOutlined,
  EditOutlined,
  EllipsisOutlined,
  ExpandOutlined,
  StopOutlined,
  UndoOutlined,
  DownOutlined,
  RedEnvelopeOutlined,
} from "@ant-design/icons";
import moment from "moment";
import * as XLSX from "xlsx";
import { JournalCentralService } from "../Services/JournalCentralService";
import { RembousementsService } from "../Services/RemboursementsService";
import "../Pages/CSS/Traitement.css";
import { AdherentsService } from "../Services/AdherentsService";
import { TraitementService } from "../Services/TraitementService";
import dayjs from "dayjs";
import Draggable from "react-draggable";

const DraggableModal = ({ children, ...props }) => {
  const [disabled, setDisabled] = useState(true);
  const draggleRef = useRef(null);

  return (
    <Modal
      {...props}
      modalRender={(modal) => (
        <Draggable
          disabled={disabled}
          bounds={draggleRef.current ? draggleRef.current : undefined}
          handle=".ant-modal-title"
        >
          <div ref={draggleRef}>{modal}</div>
        </Draggable>
      )}
      title={
        <div
          className="ant-modal-title"
          style={{ width: '100%', cursor: 'move' }}
          onMouseOver={() => setDisabled(false)}
          onMouseOut={() => setDisabled(true)}
        >
          {props.title}
        </div>
      }
    >
      {children}
    </Modal>
  );
};
const { Title } = Typography;
const { Option } = Select;

const Remboursements = () => {
  const getSelectedYear = () => {
    const currentYear = new Date().getFullYear();
    return currentYear.toString();
  };

  const initialTableData = [];
  const [tableData, setTableData] = useState(initialTableData);
  const [filteredData, setFilteredData] = useState(initialTableData);
  const [selectedYear, setSelectedYear] = useState(null);
  const [paramData, setParamData] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);

  const [selectedMonth, setSelectedMonth] = useState(null);
  const [years, setYears] = useState([]);
  const [paymentStatus, setPaymentStatus] = useState("Non");
  const [paymentType, setPaymentType] = useState("comptant");
  const [totalAmount, setTotalAmount] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedRowCredit, setSelectedRowCredit] = useState(0);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isPrintModalVisible, setIsPrintModalVisible] = useState(false);
  const [isPaymentModalVisible, setIsPaymentModalVisible] = useState(false);
  const [selectedReportType, setSelectedReportType] = useState(null);
  const [orderName, setOrderName] = useState("");
  const [cashBoxes, setCashBoxes] = useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [isExportModalVisible, setIsExportModalVisible] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [initialColumns, setInitialColumns] = useState([]);
  const [adherentsData, setAdherentsData] = useState([]);
  const [comptaPreviewData, setComptaPreviewData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [isAdvancedSearchModalVisible, setIsAdvancedSearchModalVisible] =
    useState(false);
  const [advancedSearchValues, setAdvancedSearchValues] = useState({
    matri: "",
    numpiece: "",
    datetrait: null,
    societe: "",
    participant: "",
  });

  const [selecteAdherent, setSelectedAdherent] = useState("AA");
  const [form] = Form.useForm();

  const journalCentralService = new JournalCentralService();
  const remboursementsService = new RembousementsService();
  const traitementsoinsService = new TraitementService();
  const adherentsServices = new AdherentsService();
  const fetchDataInit = async () => {
    const getParam = await traitementsoinsService.getParamComptable();
    setParamData(getParam);
    const yearFromParamData = dayjs(getParam.datedeb).format("YYYY");
    setSelectedYear(yearFromParamData)
    const monthFromParamData = dayjs(getParam.datedeb).format("MM");
    setSelectedMonth(monthFromParamData);

  };

  useEffect(() => {

    fetchDataInit();
    return () => { };
  }, []);

  const fetchData = async () => {
    try {
      const yearsData = await journalCentralService.getComptaExercices();
      setYears(yearsData);
    } catch (error) {
      notification.error({
        message: "Erreur lors de la récupération des données",
      });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchAdherents = async () => {
    try {
      const adherentsData = await adherentsServices.getAllAdherents();
      setAdherentsData(adherentsData);
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la récupération des adhérents",
      });
    }
  };

  const fetchData1 = async () => {
    if (selectedYear && selectedMonth) {
      setLoading(true);
      try {
        // 1. Récupérer les données pour l'année et le mois sélectionnés
        const data = await remboursementsService.getRemboursements(
          selectedYear,
          selectedMonth
        );
        setTableData(data);

        // 2. Filtrer les données selon le statut de paiement
        let filtered = data;

        if (paymentType === "comptant") {
          // Filtre pour les paiements au comptant (RIB)
          filtered = filtered.filter(item => item.codej === "RIB");

          // Appliquer les filtres de statut de paiement
          switch (paymentStatus) {
            case "All":
              // Garder tous les RIB
              break;
            case "Oui":
              filtered = filtered.filter(item => item.ticket_rembourse === "Oui");
              break;
            case "Non":
              filtered = filtered.filter(item => item.ticket_rembourse === "Non");
              break;
            case "Compta":
              filtered = filtered.filter(item => item.ticket_rembourse === "Compta");
              break;
            default:
              break;
          }
        } else {
          // Pour les paiements compensés (RIC)
          filtered = filtered.filter(item => item.codej === "RIC");
        }

        setFilteredData(filtered);

        // Mettre à jour les colonnes disponibles pour l'export
        if (filtered.length > 0) {
          setInitialColumns(Object.keys(filtered[0]));
          setSelectedColumns(Object.keys(filtered[0]));
        }

      } catch (error) {
        notification.error({
          message: "Erreur lors de la récupération des données",
          description: error.message
        });
      } finally {
        setLoading(false);
      }
    }
  };

  // Déclencher le rechargement des données quand un des critères change
  useEffect(() => {
    fetchData1();
  }, [selectedYear, selectedMonth, paymentStatus, paymentType]);

  const handleYearChange = (value) => {
    setSelectedYear(value);
  };

  const handleMonthChange = (value) => {
    setSelectedMonth(value);
  };



  const handleSearch = (value) => {
    // D'abord, on filtre en fonction de paymentStatus
    let filtered = tableData.filter((item) => {
      if (paymentStatus === "All") {
        return item.codej === "RIB";
      } else if (paymentStatus === "Oui") {
        return item.codej === "RIB" && item.ticket_rembourse === "Oui";
      } else if (paymentStatus === "Non") {
        return item.codej === "RIB" && item.ticket_rembourse === "Non";
      } else if (paymentStatus === "Compta") {
        return item.codej === "RIB" && item.ticket_rembourse === "Compta";
      }
      return false;
    });

    // Ensuite, on applique la recherche sur les données déjà filtrées
    if (value) {
      filtered = filtered.filter((item) =>
        Object.values(item).some(
          (val) =>
            val && val.toString().toLowerCase().includes(value.toLowerCase())
        )
      );
    }

    // Mettre à jour l'état avec les données filtrées
    setFilteredData(filtered);
  };

  const handlePaymentTypeChange = (e) => {
    setPaymentType(e.target.value);
    const filtered =
      e.target.value === "comptant"
        ? tableData.filter((item) => item.codej === "RIB")
        : tableData.filter((item) => item.codej === "RIC");
    setFilteredData(filtered);
  };

  const handlePaymentStatusChange = (e) => {
    const value = e.target.value;
    setPaymentStatus(value);

    console.log(paymentStatus, value);


    let filtered;
    if (value === "All") {
      filtered = tableData.filter((item) => item.codej === "RIB");
    } else if (value === "Oui") {
      filtered = tableData.filter(
        (item) => item.codej === "RIB" && item.ticket_rembourse === "Oui"
      );
    } else if (value === "Non") {
      filtered = tableData.filter(
        (item) => item.codej === "RIB" && item.ticket_rembourse === "Non"
      );
    } else if (value === "Compta") {
      filtered = tableData.filter(
        (item) => item.codej === "RIB" && item.ticket_rembourse === "Compta"
      );
    }

    setFilteredData(filtered);
  };

  const handlePrintClick = () => {
    setIsPrintModalVisible(true);
    fetchAdherents();
  };

  const handleCancelReglement = async (record) => {
    try {
      const data = await remboursementsService.cancelRemboursement(record);
      notification.success({
        message: "Annulation réussie",
        description: "Le règlement a été annulé avec succès",
      });
      fetchData1();
    } catch (error) {
      notification.error({
        message: "Erreur lors de l'annulation du réglement",
        description:
          error.message || "Une erreur est survenue lors de l'annulation du réglement",
      });
    }
  };

  const confirmCancel = (record) => {
    Modal.confirm({
      title: (
        <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
          Annuler le règlement du ticket N° : {record.numdoc} ?
        </div>
      ),
      content: (
        <div style={{ wordBreak: "break-word" }}>
          Cette action annulera toutes les lignes du même ticket. Voulez-vous continuer ?
        </div>
      ),
      okText: "Oui",
      okType: "danger",
      cancelText: "Non",
      width: "30%", // Ajuste la largeur pour les petits écrans
      onOk() {
        handleCancelReglement(record); // Appel de la fonction d'annulation
      },
      onCancel() {
        console.log("Annulation de l'action");
      },
    });
  };

  const handlePrintModalOk = async () => {
    try {
      const selectedData = filteredData.filter((item) =>
        selectedRowKeys.includes(item.numligne)
      );

      if (selectedData.length === 0) {
        notification.warning({
          message: "Aucune ligne sélectionnée",
          description: "Veuillez sélectionner des lignes à imprimer.",
        });
        return;
      }

      const docData = selectedData.map((item) => item.numligne);
      const codej = paymentType === "comptant" ? "RIB" : "RIC";
      const docName = selectedReportType;

      await remboursementsService.printCompta(docData);

      if (docName && docName.includes("Lettre_Cheque")) {
        const hideMessage = message.loading("Impression en cours...", 0);
        const dest = docName === "Lettre_Cheque_RIB_GLB" ? orderName : null;
        try {
          await remboursementsService.printLettreChequeService(
            docName,
            selecteAdherent,
            dest
          );
          hideMessage();
          message.success("Impression réussie !");
        } catch (error) {
          hideMessage();
          notification.error({
            message: "Erreur d'impression",
            description:
              error.message || "Une erreur est survenue lors de l'impression.",
          });
        }
      } else if (docName) {
        try {
          await remboursementsService.printRemboursementService(
            codej,
            selecteAdherent,
            docName
          );
          message.success("Impression réussie !");
        } catch (error) {
          notification.error({
            message: "Erreur d'impression",
            description:
              error.message || "Une erreur est survenue lors de l'impression.",
          });
        }
      } else {
        notification.warning({
          message: "Type de document non sélectionné",
          description: "Veuillez sélectionner un type de document à imprimer.",
        });
      }

      setIsPrintModalVisible(false);
    } catch (error) {
      notification.error({
        message: "Erreur",
        description:
          error.message ||
          "Une erreur est survenue lors de la récupération des données.",
      });
    }
  };

  const handlePrintModalCancel = () => {
    setIsPrintModalVisible(false);
    setSelectedReportType(null);
    form.resetFields();
  };

  const handleExportClick = () => {
    // Détecte la langue du système d'exploitation local
    let locale = "fr";
    if (window.navigator.userLanguage) {
      locale = window.navigator.userLanguage;
    } else if (window.navigator.language) {
      locale = window.navigator.language;
    } else if (window.navigator.languages && window.navigator.languages.length > 0) {
      locale = window.navigator.languages[0];
    }
    const dateFormat = locale.startsWith("fr") ? "DD/MM/YYYY" : "MM/DD/YYYY";

    // Récupère les lignes sélectionnées
    const selectedRows = filteredData.filter((row) => selectedRowKeys.includes(row.numligne));
    // Récupère les colonnes affichées dans le tableau (hors colonnes sans dataIndex)
    const columnsToExport = columns
      .filter(col => col.dataIndex)
      .map(col => ({
        dataIndex: col.dataIndex,
        title: typeof col.title === "string" ? col.title : ""
      }));

    // Formate les données à exporter avec les titres comme clés et formatage des dates
    const dataToExport = selectedRows.map(row => {
      const rowData = {};
      columnsToExport.forEach(col => {
        let value = row[col.dataIndex];
        // Formatage des dates si le champ contient "date"
        if (
          col.dataIndex.toLowerCase().includes("date") ||
          col.dataIndex.toLowerCase().includes("datetrait") ||
          col.dataIndex.toLowerCase().includes("datepiece") ||
          col.dataIndex.toLowerCase().includes("date_reglmt") ||
          col.dataIndex.toLowerCase().includes("datesaisie") ||
          col.dataIndex.toLowerCase().includes("datecompta")
        ) {
          value = value ? moment(value).format(dateFormat) : "";
        }
        rowData[col.title] = value;
      });
      return rowData;
    });

    // Export Excel
    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Remboursements");
    XLSX.writeFile(wb, "remboursements.xlsx");
  };

  const handleAdvancedSearchChange = (changedValues, allValues) => {
    setAdvancedSearchValues(allValues);
  };

  const handleAdvancedSearchClick = () => {
    setIsAdvancedSearchModalVisible(true);
    fetchAdherents();
  };

  const handleAdvancedSearchModalOk = () => {
    // Fermer le modal
    setIsAdvancedSearchModalVisible(false);

    // D'abord, on filtre en fonction de paymentStatus
    let filtered = tableData.filter((item) => {
      if (paymentStatus === "All") {
        return item.codej === "RIB";
      } else if (paymentStatus === "Oui") {
        return item.codej === "RIB" && item.ticket_rembourse === "Oui";
      } else if (paymentStatus === "Non") {
        return item.codej === "RIB" && item.ticket_rembourse === "Non";
      } else if (paymentStatus === "Compta") {
        return item.codej === "RIB" && item.ticket_rembourse === "Compta";
      }
      return false;
    });

    // Ensuite, on applique les critères de recherche avancée
    filtered = filtered.filter((item) => {
      const matchMatri = advancedSearchValues.matri
        ? item.matri === advancedSearchValues.matri
        : true;
      const matchNumpiece = advancedSearchValues.numpiece
        ? item.numpiece === advancedSearchValues.numpiece
        : true;
      const matchDatetrait = advancedSearchValues.datetrait
        ? moment(item.datetrait).isSame(advancedSearchValues.datetrait, "day")
        : true;
      const matchSociete = advancedSearchValues.societe
        ? item.societe === advancedSearchValues.societe
        : true;
      const matchParticipant = advancedSearchValues.participant
        ? item.participant === advancedSearchValues.participant
        : true;

      // Retourner true si tous les critères correspondent
      return (
        matchMatri &&
        matchNumpiece &&
        matchDatetrait &&
        matchSociete &&
        matchParticipant
      );
    });

    // Mettre à jour les données filtrées de la table
    setFilteredData(filtered);
  };

  const handleAdvancedSearchModalCancel = () => {
    setIsAdvancedSearchModalVisible(false);
  };



  const handlePaymentClick = async () => {
    const selectedRows = filteredData.filter((row) =>
      selectedRowKeys.includes(row.numligne)
    );
    const totalCredit = selectedRows.reduce(
      (sum, row) => sum + parseFloat(row.credit || 0),
      0
    );
    if (selectedRows.length === 0) {
      notification.warning({
        message: "Aucune ligne sélectionnée",
        description: "Veuillez sélectionner des lignes à régler.",
      });
      return;
    }

    // Calculer la somme des crédits des lignes sélectionnées

    try {
      const data = await remboursementsService.getParam3();

      if (data) {
        form.setFieldsValue({
          montantReg: totalCredit, // Affiche la somme totale des crédits
          datetrait: dayjs(data.datedeb),
        });
        setSelectedDate(dayjs(data.datedeb)); // Mettre à jour selectedDate avec la date récupérée
      } else {
        notification.error({
          message: "Erreur lors de la récupération des paramètres",
          description: "Aucune donnée retournée par le service.",
        });
      }
    } catch (error) {
      notification.error({
        message: "Erreur lors de la récupération des dates",
        description:
          error.message ||
          "Une erreur est survenue lors de la récupération des dates",
      });
    }

    setIsPaymentModalVisible(true);
  };

  const handlePaymentMethodChange = async (value) => {
    setSelectedPaymentMethod(value);
    try {
      const type =
        value === "E"
          ? "CAISSE"
          : value === "T"
            ? "TRANSFERT"
            : value === "B"
              ? "ADHERENTS"
              : "BANQUE";
      const cashBoxesData = await remboursementsService.getType(type);
      setCashBoxes(cashBoxesData);
    } catch (error) {
      notification.error({
        message: "Erreur lors de la récupération des caisses",
      });
    }
  };



  const handlePaymentModalOk = async () => {
    try {
      const values = await form.validateFields();

      // Extraire les `codesoc` des lignes sélectionnées
      const selectedRows = filteredData.filter((row) =>
        selectedRowKeys.includes(row.numligne)
      );

      const totalCredit = selectedRows.reduce(
        (sum, row) => sum + parseFloat(row.credit || 0),
        0
      );
      const codesocList = selectedRows.map((row) => row.codesoc);


      const selectedCashBox = cashBoxes.find(
        (box) => box.codej === values.cashBox
      );

      if (!selectedCashBox) {
        throw new Error("Veuillez sélectionner une caisse valide.");
      }

      // Vérifier si `dateReg` et `datetrait` sont définis avant de les convertir
      const dateReg = values.dateReg ? values.dateReg.toISOString() : null;
      const datetrait = values.datetrait
        ? values.datetrait.toISOString()
        : null;

      const payload = {
        codeBque: selectedCashBox.codej,
        dateReg: dateReg || new Date().toISOString(), // Utiliser la date du jour si non définie
        datecompta: new Date().toISOString(),
        datetrait: datetrait || new Date().toISOString(), // Utiliser la date du jour si non définie

        comptegen: selectedCashBox.compte_rattache,
        listComptas: selectedRows,
        montantReg: totalCredit,
        numReg: values.numReg,
        mode_paye: values.mode_paye,

      };

      // Afficher le popup de confirmation
      Modal.confirm({
        title: "Confirmation du règlement",
        content: `Vous allez procéder au règlement d'un montant de ${totalCredit}. Voulez-vous continuer ?`,
        okText: "Oui",
        cancelText: "Non",
        onOk: async () => {
          try {
            const result = await remboursementsService.getRembFraisMdcx(
              payload
            );
            notification.success({
              message: "Règlement réussi",
              description: "Le règlement a été effectué avec succès",
            });

            setIsPaymentModalVisible(false);

            setSelectedPaymentMethod(null);
            form.resetFields();
            fetchData1();
          } catch (error) {
            notification.error({
              message: "Erreur lors du règlement",
              description:
                error.message || "Une erreur est survenue lors du règlement",
            });
          }
        },
        onCancel() {
          console.log("Règlement annulé");
        },
      });
    } catch (error) {
      if (error.name === "Error") {
        notification.error({
          message: "Erreur de validation",
          description: error.message,
        });
      } else {
        notification.error({
          message: "Erreur lors du règlement",
          description:
            error.message || "Une erreur est survenue lors du règlement",
        });
      }
    }
  };

  const handleEditSubmit = () => {


    setIsPaymentModalVisible(false);

  };

  const handleRefreshClick = () => {
    fetchData1();
  };

  const handlePaymentModalCancel = () => {
    setIsEditMode(false);
    setIsPaymentModalVisible(false);
    form.resetFields();
    setSelectedPaymentMethod(null);
    setCashBoxes([]);
  };
  const handleComptabiliser = async () => {
    try {
      const selectedRows = filteredData.filter((row) =>
        selectedRowKeys.includes(row.numligne)
      );
      const numChequeList = selectedRows.map((row) => row.numcheque);

      // Vérifier si tous les `codesoc` sont identiques
      const uniquenumCheque = [...new Set(numChequeList)];
      if (uniquenumCheque.length > 1) {
        notification.warning({
          message: "numcheque non identiques",
          description:
            "Les lignes sélectionnées n'ont pas le même N° de Réglement. Veuillez sélectionner des lignes ayant le même N° de Réglement pour procéder à la comptabilisation.",
        });
        return; // Stopper la fonction si les codesoc ne sont pas identiques
      }

      console.log("Selected Rows: ", selectedRows); // Debugging line

      const data = await remboursementsService.PreviewCompta(selectedRows);
      console.log("Compta Preview Data: ", data); // Debugging line

      setComptaPreviewData(data);
      setIsModalOpen(true);
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données comptables :",
        error
      );
    }
  };
  const handleEdit = async (record) => {
    try {
      setIsEditMode(true);
      // Définir `selectedPaymentMethod` basé sur `record.mode_paye`
      const paymentMethod = record.mode_paye;

      // Appeler la fonction `handlePaymentMethodChange` pour gérer le type et charger les données
      await handlePaymentMethodChange(paymentMethod);

      // Préremplir les champs du formulaire
      form.setFieldsValue({
        mode_paye: paymentMethod,
        cashBox: record.code_paye || null,
        numReg: record.numcheque || null,
        dateReg: record.date_reglmt ? dayjs(record.date_reglmt) : null,
        datetrait: record.datetrait ? dayjs(record.datetrait) : null,
        montantReg: record.freels || null,
      });

      // Ouvrir le modal
      setIsPaymentModalVisible(true);
    } catch (error) {
      console.error("Erreur lors du chargement des données :", error);
      notification.error({
        message: "Erreur",
        description: "Impossible de charger les données de caisse ou banque.",
      });
    }
  };





  const columns1 = [
    {
      title: "C.JL",
      dataIndex: "codej",
      key: "codej",
      align: "center",
      sorter: (a, b) => a.codej.localeCompare(b.codej),
    },
    {
      title: "D. Compta",
      dataIndex: "datecompta",
      key: "datecompta",
      align: "center",
      render: (text, record) => (
        <div
          style={{
            whiteSpace: "nowrap",
            textAlign: "center",
            paddingLeft: "5px",
            paddingRight: "5px",
          }}
        >
          {moment(text).locale("fr").format("DD/MM/YYYY")}
        </div>
      ),
      sorter: (a, b) => a.datecompta.localeCompare(b.datecompta),
    },
    {
      title: "Mois trait.",
      dataIndex: "datetrait_reglmt",
      key: "datetrait_reglmt",
      align: "center",
      render: (text, record) => {
        const valueToRender = text || record.datetrait; // Utiliser datetrait_reg si datetrait est null ou vide
        return (
          <div
            style={{
              whiteSpace: "nowrap",
              textAlign: "center",
              paddingLeft: "5px",
              paddingRight: "5px",
            }}
          >
            {valueToRender ? moment(valueToRender).locale("fr").format("MMM YYYY") : ""}
          </div>
        );
      },
      sorter: (a, b) => a.valueToRender.localeCompare(b.valueToRender),
    },
    {
      title: "N° pièce",
      dataIndex: "numpiece",
      key: "numpiece",
      align: "center",
      sorter: (a, b) => a.numpiece.localeCompare(b.numpiece),
    },
    {
      title: "N° Chèque",
      dataIndex: "numcheque",
      key: "numcheque",
      align: "center",
      sorter: (a, b) => a.numcheque.localeCompare(b.numcheque),
    },
    {
      title: "N° F. IPM",
      dataIndex: "numfactipm",
      key: "numfactipm",
      align: "center",
      sorter: (a, b) => a.numfactipm.localeCompare(b.numfactipm),
    },
    {
      title: "Cpte. Gen.",
      dataIndex: "comptegen",
      key: "comptegen",
      align: "center",
      sorter: (a, b) => a.comptegen.localeCompare(b.comptegen),
    },
    {
      title: "Cpte. Tiers",
      dataIndex: "comptetiers",
      key: "comptetiers",
      align: "center",
      sorter: (a, b) => a.comptetiers.localeCompare(b.comptetiers),
    },
    {
      title: "Libellé",
      dataIndex: "libelle",
      key: "libelle",
      sorter: (a, b) => a.libelle.localeCompare(b.libelle),
    },
    {
      title: "Débit",
      dataIndex: "debit",
      key: "debit",
      align: "right",
      render: (text) => (
        <div style={{ paddingRight: 5 }}>
          {text && parseFloat(text) !== 0 ? formatNumber(parseFloat(text)) : ""}
        </div>
      ),
      sorter: (a, b) => a.debit.localeCompare(b.debit),
    },
    {
      title: "Crédit",
      dataIndex: "credit",
      key: "credit",
      align: "right",
      render: (text) => (
        <div style={{ paddingRight: 5 }}>
          {text && parseFloat(text) !== 0 ? formatNumber(parseFloat(text)) : ""}
        </div>
      ),
      sorter: (a, b) => a.credit.localeCompare(b.credit),
    },

  ];

  const exportToExcel = (data, fileName) => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  };

  const prepareDataForExport = (data) => {
    return data.map((row) => ({
      CodeJ: row.codej,
      DateCompta: row.datecompta,
      MoisTrait: row.datetrait,
      NumPiece: row.numpiece,
      NumCheque: row.numcheque,
      NumFIPM: row.numfactipm,
      CompteGen: row.comptegen,
      CompteTiers: row.comptetiers,
      Matricule: row.matri,
      Libelle: row.libelle,
      Debit: row.debit,
      Credit: row.credit,
    }));
  };
  const totalDebit1 = comptaPreviewData.reduce(
    (sum, record) => sum + parseFloat(record.debit || 0),
    0
  );
  const totalCredit1 = comptaPreviewData.reduce(
    (sum, record) => sum + parseFloat(record.credit || 0),
    0
  );
  const solde1 = totalDebit1 - totalCredit1;

  const totalFreel = filteredData.reduce(
    (sum, record) => sum + parseFloat(record.credit || 0),
    0
  );

  const handleValidCompta = async () => {
    try {
      /*  const selectedRows = tableData.filter((row) =>
        selectedRowKeys.includes(row.numligne)
      ); */
      const payload = comptaPreviewData;
      const data = await remboursementsService.validComptaReg(payload);
      setIsModalOpen(false);
      fetchData1();
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données comptables :",
        error
      );
    }
  };

  const onchangeAdherent = (value) => {
    setSelectedAdherent(value);
  };
  function formatNumber(number) {
    return new Intl.NumberFormat("fr-FR").format(number);
  }

  const columns = [
    {
      title: "C.JL",
      dataIndex: "codej",
      key: "codej",
      align: "center",
      fixed: "left",
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "left", paddingRight: 5, paddingLeft: 5 }}>
          {text}
        </div>
      ),
      sorter: (a, b) => (a.codej || "").localeCompare(b.codej || ""),
    },
    {
      title: "Date Pièce",
      dataIndex: "datepiece",
      key: "datepiece",
      align: "center",
      render: (text, record) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "center", paddingRight: 5, paddingLeft: 5 }}>
          {record.datepiece ? moment(record.datepiece).locale("fr").format("DD MMM YYYY") : ""}
        </div>
      ),
      sorter: (a, b) => (a.datepiece && b.datepiece ? moment(a.datepiece).diff(moment(b.datepiece)) : 0),
    },
    {
      title: "Mois trait.",
      dataIndex: "datetrait",
      key: "datetrait",
      align: "center",
      render: (text, record) => {
        const valueToRender = text || record.datetrait; // Utiliser datetrait_reg si datetrait est null ou vide
        return (
          <div
            style={{
              whiteSpace: "nowrap",
              textAlign: "center",
              paddingLeft: "5px",
              paddingRight: "5px",
            }}
          >
            {valueToRender ? moment(valueToRender).locale("fr").format("MMM YYYY") : ""}
          </div>
        );
      },
      sorter: (a, b) => (a.valueToRender && b.valueToRender ? moment(a.valueToRender).diff(moment(b.valueToRender)) : 0),
    },
    {
      title: "Date Saisie",
      dataIndex: "datesaisie",
      key: "datesaisie",
      align: "center",
      render: (text, record) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "center", paddingLeft: 5, paddingRight: 5 }}>
          {record.datesaisie ? moment(record.datesaisie).locale("fr").format("DD/MM/YYYY") : ""}
        </div>
      ),
      sorter: (a, b) => (a.datesaisie && b.datesaisie ? moment(a.datesaisie).diff(moment(b.datesaisie)) : 0),
    },
    {
      title: "N° ticket",
      dataIndex: "numdoc",
      key: "numdoc",
      align: "center",
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "left", paddingRight: 5, paddingLeft: 5 }}>
          {text}
        </div>
      ),
      sorter: (a, b) => (a.numdoc || "").localeCompare(b.numdoc || ""),
    },
    {
      title: "N° Fact. IPM",
      dataIndex: "numfactipm",
      key: "numfactipm",
      align: "center",
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "center", paddingRight: 5, paddingLeft: 5 }}>
          {text}
        </div>
      ),
      sorter: (a, b) => (a.numfactipm || "").localeCompare(b.numfactipm || ""),
    },
    {
      title: "Participant",
      dataIndex: "participant",
      key: "participant",
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "left", paddingRight: 5, paddingLeft: 5 }}>
          {text}
        </div>
      ),
      sorter: (a, b) => (a.participant || "").localeCompare(b.participant || ""),
    },
    {
      title: "Soc. Mat",
      dataIndex: "comptetiers",
      key: "comptetiers",
      align: "center",
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "left", paddingRight: 5, paddingLeft: 5 }}>
          {text}
        </div>
      ),
      sorter: (a, b) => (a.comptetiers || "").localeCompare(b.comptetiers || ""),
    },
    {
      title: "Libellé",
      dataIndex: "libelle",
      key: "libelle",
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "left", paddingRight: 5, paddingLeft: 5 }}>
          {text}
        </div>
      ),
      sorter: (a, b) => (a.libelle || "").localeCompare(b.libelle || ""),
    },
    {
      title: "Remboursé",
      dataIndex: "ticket_rembourse",
      key: "ticket_rembourse",
      align: "center",
      render: (_, record) => (
        <div style={{ paddingRight: 10 }}>
          {record.ticket_rembourse === "Non" ? (
            <StopOutlined style={{ color: "red" }} />
          ) : record.ticket_rembourse === "Compta" ? (
            <AccountBookOutlined style={{ color: "blue" }} />
          ) : (
            <CheckCircleOutlined style={{ color: "green" }} />
          )}
        </div>
      ),
      sorter: (a, b) => (a.ticket_rembourse || "").localeCompare(b.ticket_rembourse || ""),
    },
    {
      title: "N° Réglement",
      dataIndex: "numcheque",
      key: "numcheque",
      align: "center",
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "left", paddingRight: 5, paddingLeft: 5 }}>
          {text}
        </div>
      ),
      sorter: (a, b) => (a.numcheque || "").localeCompare(b.numcheque || ""),
    },
    {
      title: "Date Réglement",
      dataIndex: "date_reglmt",
      key: "date_reglmt",
      align: "center",
      render: (text, record) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "center", paddingRight: 5, paddingLeft: 5 }}>
          {record.date_reglmt ? moment(record.date_reglmt).locale("fr").format("DD MMM YYYY") : ""}
        </div>
      ),
      sorter: (a, b) => (a.date_reglmt && b.date_reglmt ? moment(a.date_reglmt).diff(moment(b.date_reglmt)) : 0),
    },
    {
      title: "Mode de Paiement",
      dataIndex: "mode_paye",
      key: "mode_paye",
      align: "center",
      render: (mode) => {
        let color = "";
        let text = "";

        switch (mode) {
          case "E":
            color = "#26a805";
            text = "Espèce";
            break;
          case "C":
            color = "#166bf5";
            text = "Chèque";
            break;
          case "V":
            color = "#f28a02";
            text = "Virement";
            break;
          case "T":
            color = "#800080";
            text = "Transfert";
            break;
          case "B":
            color = "#FF00FF";
            text = "Sur Bulletin";
            break;
          default:
            color = "default";
            text = mode;
        }

        return <Tag color={color}>{text}</Tag>;
      },
      sorter: (a, b) => (a.mode_paye || "").localeCompare(b.mode_paye || ""),
    },
    {
      title: "Frais réel",
      dataIndex: "freels",
      key: "freels",
      align: "right",
      render: (text) => (
        <div style={{ paddingRight: 10 }}>
          <strong>{formatNumber(text && parseFloat(text) !== 0 ? parseFloat(text) : "")}</strong>
        </div>
      ),
      sorter: (a, b) => (parseFloat(a.freels) || 0) - (parseFloat(b.freels) || 0),
    },
    {
      title: "Montant dû",
      dataIndex: "credit",
      key: "credit",
      align: "right",
      render: (text) => (
        <div style={{ paddingRight: 10 }}>
          <strong>{formatNumber(text && parseFloat(text) !== 0 ? parseFloat(text) : "")}</strong>
        </div>
      ),
      sorter: (a, b) => (parseFloat(a.credit) || 0) - (parseFloat(b.credit) || 0),
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            padding: "1px",
          }}
        ></div>
      ),
      key: "action",
      align: "center",
      render: (record) =>
        paymentStatus === "Oui" ? (
          <Button
            icon={<UndoOutlined
              style={{ cursor: "pointer", color: "red", marginRight: 8 }}
            />}
            type="text"
            onClick={() => confirmCancel(record)}
          />
        ) : null,
    },
  ];



  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys) => {
      setSelectedRowKeys(selectedRowKeys);
    },
    selections: [
      {
        key: "select-all",
        text: (
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <CheckSquareOutlined style={{ color: "#52c41a" }} />
            Sélectionner toutes les lignes
          </span>
        ),
        onSelect: () => {
          const allKeys = filteredData.map((item) => item.numligne);
          setSelectedRowKeys(allKeys);
        },
      },
      {
        key: "clear-selection",
        text: (
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <CloseSquareOutlined style={{ color: "#ff4d4f" }} />
            Désélectionner toutes les lignes
          </span>
        ),
        onSelect: () => {
          setSelectedRowKeys([]);
        },
      },
    ],
    getCheckboxProps: (record) => ({
      name: record.numligne,
    }),
  };

  const monthOptions = [
    { value: "13", label: "Tous les mois" },
    { value: "01", label: "Janvier" },
    { value: "02", label: "Février" },
    { value: "03", label: "Mars" },
    { value: "04", label: "Avril" },
    { value: "05", label: "Mai" },
    { value: "06", label: "Juin" },
    { value: "07", label: "Juillet" },
    { value: "08", label: "Août" },
    { value: "09", label: "Septembre" },
    { value: "10", label: "Octobre" },
    { value: "11", label: "Novembre" },
    { value: "12", label: "Décembre" },
  ];

  const handleMenuClick = ({ key }) => {
    handlePaymentStatusChange({ target: { value: key } });
  };



  const menu = (
    <Menu>
      <Menu.Item
        key="export"
        disabled={selectedRowKeys.length === 0}
        onClick={handleExportClick}
      >
        Export Excel
      </Menu.Item>
      <Menu.Item
        key="print"
        disabled={selectedRowKeys.length === 0}
        onClick={handlePrintClick}
      >
        Imprimer
      </Menu.Item>
      {/* <Menu.Item
        key="pay"
        disabled={selectedRowKeys.length === 0 || paymentStatus !== "Non"}
        onClick={handlePaymentClick}
      >
        Régler
      </Menu.Item> */}
      <Menu.Item key="refresh" onClick={handleRefreshClick}>
        Actualiser
      </Menu.Item>
    </Menu>
  );

  const selectionMenu = (
    <Menu>
      <Menu.Item
        key="selectAll"
        onClick={() => {
          const allKeys = filteredData.map((item) => item.numligne);
          setSelectedRowKeys(allKeys);
        }}
      >
        Tout sélectionner
      </Menu.Item>
      <Menu.Item
        key="deselectAll"
        onClick={() => {
          setSelectedRowKeys([]);
        }}
      >
        Tout désélectionner
      </Menu.Item>
    </Menu>
  );

  return (
    <div style={{ padding: 12 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "10px 20px",
          background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
          borderRadius: 10,
          boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
          marginBottom: 16,
        }}
      >
        <RedEnvelopeOutlined style={{ fontSize: 22, color: "#fff" }} />
        <span
          style={{
            fontSize: 18,
            fontWeight: 600,
            color: "#fff",
            letterSpacing: 0.5,
            margin: 0,
          }}
        >
          Remboursements Frais Médicaux
        </span>
      </div>


      <Row gutter={16}>
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={8}
          style={{ display: "flex", justifyContent: "start", marginTop: 16 }}
        >
          <Space wrap>
            <Space
              direction="vertical"
              style={{ marginRight: 12, textAlign: "left" }}
            >
              <label>Exercice</label>
              <Select
                bordered={false}
                style={{ borderBottom: "2px solid #030303", width: "100%" }}
                onChange={handleYearChange}
                value={selectedYear}
              >
                {years.map((year) => (
                  <Option key={year} value={year}>
                    {year}
                  </Option>
                ))}
              </Select>
            </Space>
            <Space direction="vertical" style={{ textAlign: "left" }}>
              <label>Mois</label>
              <Select
                bordered={false}
                style={{ borderBottom: "2px solid #030303", width: "150px" }}
                onChange={setSelectedMonth}
                value={selectedMonth}
              >
                {monthOptions.map((month) => (
                  <Option key={month.value} value={month.value}>
                    {month.label}
                  </Option>
                ))}
              </Select>
            </Space>
            <Space style={{ marginTop: 25 }}>

              <Input
                placeholder="Recherche..."
                bordered={false}
                prefix={
                  <ExpandOutlined
                    onClick={handleAdvancedSearchClick}
                    style={{ cursor: "pointer" }}
                  />
                }
                style={{ borderBottom: "2px solid black", width: "100%" }}
                onChange={(e) => handleSearch(e.target.value)}
                onPressEnter={(e) => handleSearch(e.target.value)}
              />
            </Space>
          </Space>
        </Col>
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={16}
          style={{ display: "flex", justifyContent: "end", alignItems: "end" }}
        >
          <Space wrap>
            <div style={{ display: "flex", gap: 8 }}>
              {[
                { value: "comptense", label: "compense" },
                { value: "comptant", label: "comptant" },
              ].map((item) => (
                <button
                  key={item.value}
                  onClick={() => handlePaymentTypeChange({ target: { value: item.value } })}
                  style={{
                    padding: "6px 14px",
                    borderRadius: 20,
                    border: "none",
                    cursor: "pointer",
                    fontSize: 13,
                    fontWeight: 500,
                    transition: "all 0.3s ease",
                    background: paymentType === item.value
                      ? "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)"
                      : "#f0f0f0",
                    color: paymentType === item.value ? "#fff" : "#595959",
                    boxShadow: paymentType === item.value
                      ? "0 3px 10px rgba(24, 144, 255, 0.4)"
                      : "0 1px 3px rgba(0, 0, 0, 0.1)",
                  }}
                  onMouseEnter={(e) => {
                    if (paymentType !== item.value) {
                      e.currentTarget.style.background = "#e0e0e0";
                      e.currentTarget.style.transform = "translateY(-1px)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (paymentType !== item.value) {
                      e.currentTarget.style.background = "#f0f0f0";
                      e.currentTarget.style.transform = "translateY(0)";
                    }
                  }}
                >
                  {item.label}
                </button>
              ))}
            </div>
            <Button
              disabled={selectedRowKeys.length === 0 || paymentStatus !== "Non"}
              className="buttonExport"
              onClick={handlePaymentClick}
            >
              Régler
            </Button>
            <Button
              disabled={selectedRowKeys.length === 0 || paymentStatus !== "Oui"}
              className="buttonCompta"
              onClick={handleComptabiliser}
            >
              Comptabiliser
            </Button>
            {paymentType === "comptant" && (
              <div style={{ display: "flex", gap: 8 }}>
                {[
                  { value: "All", label: "Tous" },
                  { value: "Non", label: "Non Réglés" },
                  { value: "Oui", label: "Réglés" },
                  { value: "Compta", label: "Comptabilisés" },
                ].map((item) => (
                  <button
                    key={item.value}
                    onClick={() => handlePaymentStatusChange({ target: { value: item.value } })}
                    style={{
                      padding: "6px 14px",
                      borderRadius: 20,
                      border: "none",
                      cursor: "pointer",
                      fontSize: 13,
                      fontWeight: 500,
                      transition: "all 0.3s ease",
                      background: paymentStatus === item.value
                        ? "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)"
                        : "#f0f0f0",
                      color: paymentStatus === item.value ? "#fff" : "#595959",
                      boxShadow: paymentStatus === item.value
                        ? "0 3px 10px rgba(24, 144, 255, 0.4)"
                        : "0 1px 3px rgba(0, 0, 0, 0.1)",
                    }}
                    onMouseEnter={(e) => {
                      if (paymentStatus !== item.value) {
                        e.currentTarget.style.background = "#e0e0e0";
                        e.currentTarget.style.transform = "translateY(-1px)";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (paymentStatus !== item.value) {
                        e.currentTarget.style.background = "#f0f0f0";
                        e.currentTarget.style.transform = "translateY(0)";
                      }
                    }}
                  >
                    {item.label}
                  </button>
                ))}
              </div>
            )}
            <Dropdown overlay={menu} trigger={["click"]}>
              <Button
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "40px",
                  height: "40px",
                  padding: "0",
                }}
              >
                <EllipsisOutlined />
              </Button>
            </Dropdown>

          </Space>
        </Col>
      </Row>

      <Card bordered={false}>
        <Table
          //ajoute un title en haut de la table
          title={() => (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <b>
                {filteredData.length} ticket(s) / Montant Total: {formatNumber(totalFreel)}
              </b>
              <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                {/* Ajoutez ici le dropdown Sélection */}
                <Dropdown overlay={selectionMenu} trigger={["click"]}>
                  <Button style={{ marginRight: 8, backgroundColor: "#84ae5bff" }}>
                    Sélection <DownOutlined />
                  </Button>
                </Dropdown>
              </span>
            </div>
          )}

          id="tabRemboursement"
          rowSelection={rowSelection}
          scroll={{ x: true }}
          style={{
            cursor: "pointer",
            whiteSpace: "nowrap",
            width: "100%",
            overflow: "auto",
          }}
          className="custom-header2-table"
          bordered
          pagination={{
            pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
            showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
            pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
            onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
          }}
          rowClassName={(record) =>
            selectedRowKeys.includes(record.numligne) ? "selected-row" : ""
          }
          showSorterTooltip={false}
          columns={columns}
          dataSource={filteredData}
          loading={loading}
          rowKey={(record) => record.numligne}
        />
      </Card>

      <DraggableModal
        title="Type Etat"
        open={isPrintModalVisible}
        onOk={handlePrintModalOk}
        onCancel={handlePrintModalCancel}
        width={800}
        style={{ top: 20 }}
        maskClosable={false}
        footer={[
          <Button key="back" onClick={handlePrintModalCancel}>
            Fermer
          </Button>,
          <Button key="submit" type="primary" onClick={handlePrintModalOk}>
            Imprimer
          </Button>,
        ]}
      >
        <Form layout="vertical">
          <Form.Item label="Type Etat">
            <Select
              bordered={false}
              style={{ borderBottom: "1px solid black" }}
              onChange={setSelectedReportType}
            >
              <Option value="Etat_Remboursement_GLB">
                Etat remboursements global
              </Option>
              <Option value="Etat_Remboursement_INDIV">
                Etat remboursements individuel
              </Option>
              <Option value="Lettre_Cheque_RIB_GLB">
                Lettre chèque globale
              </Option>
              <Option value="Lettre_Cheque_RIB_INDIV">
                Lettre chèque individuelle
              </Option>
            </Select>
          </Form.Item>
          {selectedReportType === "Lettre_Cheque_RIB_GLB" && (
            <Form.Item label="À l'ordre de...">
              <Input
                name="dest"
                value={orderName}
                onChange={(e) => setOrderName(e.target.value)}
              />
            </Form.Item>
          )}
          <Form.Item
            name="codeadht"
            label="Société"
            initialValue={selecteAdherent}
          >
            <Select
              bordered={false}
              style={{ borderBottom: "1px solid black" }}
              onChange={onchangeAdherent}
            >
              <Select.Option value="AA">Toutes les sociétés</Select.Option>
              {adherentsData.map((adherent) => (
                <Option key={adherent.codeadht} value={adherent.codeadht}>
                  {adherent.codeadht} - {adherent.intitule}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </DraggableModal>

      <DraggableModal
        title="Méthode de Règlement"
        open={isPaymentModalVisible}
        onOk={isEditMode ? handleEditSubmit : handlePaymentModalOk}
        onCancel={handlePaymentModalCancel}
        width={800}
        maskClosable={false}
        footer={[
          <Button key="back" onClick={handlePaymentModalCancel}>
            Annuler
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={isEditMode ? handleEditSubmit : handlePaymentModalOk}
          >
            {isEditMode ? "Modifier" : "Valider"}
          </Button>,
        ]}
      >
        <Form layout="vertical" form={form}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="mode_paye"
                label="Méthode de Remboursement"
                rules={[
                  {
                    required: true,
                    message: "Veuillez sélectionner une méthode de paiement",
                  },
                ]}
              >
                <Select
                  placeholder="Sélectionner une méthode"
                  onChange={handlePaymentMethodChange}
                >
                  <Option value="E">Espèce</Option>
                  <Option value="C">Chèque</Option>
                  <Option value="V">Virement</Option>
                  <Option value="T">Transfert</Option>
                  <Option value="B">Sur Bulletin</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="cashBox"
                label={
                  selectedPaymentMethod === "C"
                    ? "BANQUE"
                    : selectedPaymentMethod === "V"
                      ? "BANQUE"
                      : selectedPaymentMethod === "T"
                        ? "TRANSFERT"
                        : selectedPaymentMethod === "B"
                          ? "BULLETIN"
                          : selectedPaymentMethod === "E"
                            ? "CAISSE"
                            : "\u00A0"
                }
                rules={[
                  {
                    required: true,
                    message: "Veuillez sélectionner ",
                  },
                ]}
              >
                <Select
                  placeholder="Sélectionner..."
                  showSearch
                  allowClear={true}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {cashBoxes.map((box) => (
                    <Option key={box.codej} value={box.codej}>
                      {` ${box.codej} - ${box.libelle}`}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          {selectedPaymentMethod === "C" && (
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="numReg"
                  label="N° Chèque"
                  rules={[
                    { required: true, message: "Veuillez entrer le N° Chèque" },
                  ]}
                >
                  <Input placeholder="N° Chèque" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="dateReg"
                  label="Date Chèque"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez entrer la Date Chèque",
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    placeholder="Date Chèque"
                    disabledDate={(current) => current && current > dayjs().endOf('day')}
                  />
                </Form.Item>
              </Col>
            </Row>
          )}
          {selectedPaymentMethod === "V" && (
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="numReg"
                  label="N° Virement"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez entrer le N° Virement",
                    },
                  ]}
                >
                  <Input placeholder="N° Virement" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="dateReg"
                  label="Date Virement"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez entrer la Date Virement",
                    },
                  ]}
                >
                  <DatePicker
                    placeholder="Date Transfert"
                    style={{ width: "100%" }}
                    format={"DD/MM/YYYY"}
                    disabledDate={(current) => current && current > dayjs().endOf('day')}
                  />
                </Form.Item>
              </Col>
            </Row>
          )}
          {selectedPaymentMethod === "T" && (
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="numReg"
                  label="Code Transfert"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez entrer le Code Transfert",
                    },
                  ]}
                >
                  <Input placeholder="Code Transfert" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="dateReg"
                  label="Date Transfert"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez entrer la Date Transfert",
                    },
                  ]}
                >
                  <DatePicker
                    placeholder="Date Transfert"
                    style={{ width: "100%" }}
                    format={"DD/MM/YYYY"}
                    disabledDate={(current) => current && current > dayjs().endOf('day')}
                  />
                </Form.Item>
              </Col>
            </Row>
          )}
          {selectedPaymentMethod === "B" && (
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="numReg"
                  label="Mois - Années"
                  rules={[
                    {
                      required: "champs  requis ",
                    },
                  ]}
                >
                  <Input placeholder="" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="dateReg"
                  label="Date Remboursement"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez entrer la Date ",
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    placeholder="Date "
                    format={"DD/MM/YYYY"}
                    disabledDate={(current) => current && current > dayjs().endOf('day')}
                  />
                </Form.Item>
              </Col>
            </Row>
          )}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="montantReg" label="Montant">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              {/*  <Form.Item name="datetrait" label="Mois Traitement">
                <DatePicker disabled  format={"MMM/YYYY"} />
              </Form.Item> */}
              <Row gutter={16}>
                <Col span={20}>
                  <Form.Item name="datetrait" label="Mois Traitement">
                    <DatePicker
                      disabled
                      format={"MMM YYYY"}
                      style={{ width: "100%" }}
                      value={selectedDate}
                    />
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <div style={{ paddingTop: "30px" }}>
                    <Popover
                      placement="bottomCenter"
                      content={
                        <DatePicker
                          format="MMM-YYYY"
                          picker="month"
                          value={selectedDate}
                          onChange={(date) => {
                            setSelectedDate(date);
                            form.setFieldsValue({ datetrait: date });
                          }}
                          disabledDate={(current) => current && current > dayjs().endOf('day')}
                        />
                      }
                      trigger="click"
                    >
                      <Button icon={<CalendarOutlined />} />
                    </Popover>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </DraggableModal>

      {/* Modal Compta Preview */}
      <DraggableModal
        title="Aperçu écritures au journal"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        maskClosable={false}
        footer={[
          <Button
            className="buttonExport"
            onClick={() =>
              exportToExcel(
                prepareDataForExport(comptaPreviewData),
                "Aperçu Ecriture au Journal.xlsx"
              )
            }
          >
            Export
          </Button>,
          <Button
            key="back"
            className="buttonClose"
            onClick={() => setIsModalOpen(false)}
          >
            Fermer
          </Button>,
          <Button
            className="Buttonvalid"
            disabled={solde1 !== 0}
            onClick={handleValidCompta}
          >
            Valider
          </Button>,
        ]}
        width={1200}
        style={{ top: 20 }}
      >
        <Input
          placeholder="Recherche..."
          bordered={false}
          style={{
            borderBottom: "2px solid #030303",
            width: "20%",
            marginBottom: 30,
          }}
        />
        <Table
          scroll={{
            x: true,
            // y: "240px",
          }}
          className="custom-header2-table"
          style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
          bordered
          showSorterTooltip={false}
          dataSource={comptaPreviewData}
          columns={columns1}
          footer={() => (
            <div style={{ textAlign: "right" }}>
              <Space>
                <strong>Total Debit{formatNumber(totalDebit1)} </strong>
                <strong>Total Crédit : {formatNumber(totalCredit1)}</strong>
                <strong> Solde : {formatNumber(solde1)}</strong>
              </Space>
            </div>
          )}
        />
      </DraggableModal>
      <DraggableModal
        title="Recherche Avancée"
        open={isAdvancedSearchModalVisible}
        onOk={handleAdvancedSearchModalOk}
        onCancel={handleAdvancedSearchModalCancel}
        width={600}
      >
        <Form
          layout="vertical"
          onValuesChange={handleAdvancedSearchChange}
          initialValues={advancedSearchValues}
        >
          <Form.Item label="Matricule" name="matri">
            <Input placeholder="Entrez le matricule" />
          </Form.Item>
          <Form.Item label="Société" name="societe">
            {/*  <Select
              placeholder="Sélectionnez une société"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {adherentsData.map((adherent) => (
                <Select.Option
                  key={adherent.codeadht}
                  value={adherent.codeadht}
                >
                  {adherent.intitule}
                </Select.Option>
              ))}
            </Select> */}
            <Input />
          </Form.Item>
          <Form.Item label="Participant" name="participant">
            <Input placeholder="Entrez le participant" />
          </Form.Item>
          <Form.Item label="N° Pièce" name="numpiece">
            <Input placeholder="Entrez le numéro de pièce" />
          </Form.Item>
          <Form.Item label="Date Traitement" name="datetrait">
            <DatePicker
              style={{ width: "100%" }}
              format="DD/MM/YYYY"
              disabledDate={(current) => current && current > dayjs().endOf('day')}
            />
          </Form.Item>
        </Form>
      </DraggableModal>
    </div>
  );
};

export default Remboursements;
